import type { MissionChapter } from '../../blocks/mission'

/**
 * 現在チャプターの seq。チャプター情報が無ければ undefined。
 *
 * Widget（digitane 動画）はチャプターを seq で指定・通知するため、
 * missionManager の chapterIndex との変換はこの seq を介して行う。
 */
export const getCurrentChapterSeq = (manager: {
  chapter: MissionChapter | null
}): number | undefined => manager.chapter?.chapter?.seq

/** seq が一致するチャプターの index。無ければ（seq が undefined のときも）undefined */
export const findChapterIndexBySeq = (
  chapters: ReadonlyArray<MissionChapter>,
  seq: number | undefined,
): number | undefined => {
  if (seq === undefined) return undefined

  const index = chapters.findIndex((item) => item.chapter?.seq === seq)
  return index >= 0 ? index : undefined
}
